module.exports = __webpack_public_path__ + "img/DO.b240de12.svg";